import { TransformedConfigurationComponent_Field } from "src/api/generated/erp/configurator/componentTransformation/model/transformedConfigurationComponent.ts";

export function getConfiguratorFieldComponentLabelWithRequiredMark(
	field: TransformedConfigurationComponent_Field,
): string {
	return field.label + (field.required ? " *" : "");
}